import { memo } from 'react';
const SvgUnderline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="underline_svg__feather underline_svg__feather-underline"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3M4 21h16" />
  </svg>
);
const Memo = memo(SvgUnderline);
export default Memo;
